import React from 'react';

export const TOOL_DISCLAIMER_TITLE = 'RadarBI es una herramienta, no una predicción';

export const TOOL_DISCLAIMER_SHORT =
  'Te juntamos datos públicos y cálculos del rubro para que decidas con más información a la mano. No adivinamos el futuro, no prometemos ventas ni rentabilidad, y el resultado de tu negocio depende de cómo lo operes.';

export const TOOL_DISCLAIMER_LOGIN =
  'RadarBI te entrega información de la zona. No predice el futuro ni garantiza que el negocio vaya a ir bien.';

export const TOOL_DISCLAIMER_ACCEPT =
  'He leído y entiendo que RadarBI solo entrega información de apoyo. No predice resultados ni garantiza el éxito de un local.';

export const TOOL_DISCLAIMER_ACCEPT_SHORT =
  'Entiendo que RadarBI es una herramienta de apoyo, no una promesa de resultados.';

export function ToolDisclaimerAccept({
  accepted,
  onChange,
  variant = 'purchase',
  id,
}: {
  accepted: boolean;
  onChange: (next: boolean) => void;
  variant?: 'login' | 'purchase';
  id: string;
}) {
  const compact = variant === 'login';
  return (
    <div className={`tool-disclaimer${compact ? ' is-compact' : ''}`}>
      {!compact && <strong>{TOOL_DISCLAIMER_TITLE}</strong>}
      <p>{compact ? TOOL_DISCLAIMER_LOGIN : TOOL_DISCLAIMER_SHORT}</p>
      <label htmlFor={id}>
        <input
          id={id}
          type="checkbox"
          checked={accepted}
          onChange={(event) => onChange(event.target.checked)}
        />
        <span>{compact ? TOOL_DISCLAIMER_ACCEPT_SHORT : TOOL_DISCLAIMER_ACCEPT}</span>
      </label>
    </div>
  );
}
